import { render, staticRenderFns } from "./weekLIst.vue?vue&type=template&id=d0ca6a3e&scoped=true"
import script from "./weekLIst.vue?vue&type=script&lang=js"
export * from "./weekLIst.vue?vue&type=script&lang=js"
import style0 from "./weekLIst.vue?vue&type=style&index=0&id=d0ca6a3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ca6a3e",
  null
  
)

export default component.exports